// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BreedingFemale, BreedingFemaleSchema } from 'api/gen/BreedingFemale';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';

const requiredPart = t.interface({
  content: t.union([t.array(BreedingFemaleSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelBreedingFemaleSchema = excess(requiredPart);

export interface PagedModelBreedingFemale extends t.TypeOf<typeof PagedModelBreedingFemaleSchema> {}
